// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3szqg","resendInfoText":"OnGoingPaymentBox_resendInfoText__2RffB"};